import React from 'react';
import classnames from 'classnames';
import type { UAPPlacementComponentProps } from '../@types';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { getLargeAdChoiceIconStyles } from '../styles';

const CircleRightArrowImpl = ({
  classes,
  customizedClassName,
}: UAPPlacementComponentProps) => (
  <div className={classnames(classes.largeIconRoot, customizedClassName)}>
    <svg className={classes.arrowIcon} width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1.5L8 7.5L1 13.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);

export const CircleRightArrow = withUAPLThemedStyles(
  CircleRightArrowImpl,
  getLargeAdChoiceIconStyles,
  { componentName: 'LargeChoiceIcon' }
);
